import React from 'react';
import Parse from 'parse';
import {Nav, Navbar, NavItem} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import {Link, withRouter} from 'react-router-dom';
import Auth from './auth.js';

const AuthButton = withRouter(({history}) => (
    Auth.isAuthenticated ? (
        <NavItem onClick={() => {
            Auth.signOut().then(() => history.push('/'))
        }}>Sign out</NavItem>
    ) : (
        <LinkContainer to="/sign-in">
            <NavItem>Sign in</NavItem>
        </LinkContainer>
    )
));

export default class NavbarInstance extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            admin: false
        };
    }

    componentDidMount() {

        let _this = this;
        let currentUser = Parse.User.current();
        if (currentUser !== null) {
            currentUser.fetch().then(user => {
                _this.setState({admin: user.get("admin")})
            })
        }

    }

    render() {
        return (
            <Navbar collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">ATApp</Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <LinkContainer exact to="/">
                            <NavItem>Home</NavItem>
                        </LinkContainer>
                    {this.state.admin &&
                    (
                            <LinkContainer to="/admin">
                                <NavItem>Admin</NavItem>
                            </LinkContainer>
                    )
                    }
                    </Nav>
                    <Nav pullRight>
                        <AuthButton/>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        )
    }
};


// WEBPACK FOOTER //
// ./src/navbar.js